import {
  createEmailTemplate,
  fetchAllEmailTemplate,
  fetchPartialEmailTemplates,
  fetchEmailTemplateById,
  updateEmailTemplate,
  deleteEmailTemplate,
  resetSelectedEmailTemplate,
  duplicateEmailTemplate,
} from '../routines/emailEditorTemplateRoutine';

const initialState = {
  emailTemplateList: [],
  paginationData: {},
  emailTemplateListLoading: false,
  emailTemplateListSuccess: false,
  emailTemplateListPartial: [],
  emailTemplateListPartialLoading: false,
  emailTemplateListPartialSuccess: false,
  selectedEmailTemplate: null,
  selectedEmailTemplateLoading: false,
  selectedEmailTemplateSuccess: false,
  emailTemplateCreating: false,
  emailTemplateCreateSuccess: false,
  emailTemplateUpdating: false,
  emailTemplateUpdateSuccess: false,
  emailTemplateDeleting: false,
  emailTemplateDuplicating: false,
  emailTemplateDuplicateSuccess: false,
};

const emailTemplateReducer = (state = initialState, action) => {
  switch (action.type) {
    // fetch email template
    case fetchAllEmailTemplate.TRIGGER:
      return {
        ...state,
        emailTemplateListSuccess: false,
        emailTemplateListLoading: true,
      };
    case fetchAllEmailTemplate.SUCCESS:
      // eslint-disable-next-line no-case-declarations
      const { response, currentPayload } = action.payload;
      return {
        ...state,
        emailTemplateListLoading: false,
        emailTemplateListSuccess: true,
        emailTemplateList: response?.data.templates || [],
        paginationData: {
          page: response.data.page,
          publicItems: response.data.public,
          privateItems: response.data.private,
          totalItems: response.data.total,
        },
        currentPayload,
      };
    case fetchAllEmailTemplate.FAILURE:
      return {
        ...state,
        emailTemplateListLoading: false,
        emailTemplateListSuccess: false,
      };

    // fetch partial email template
    case fetchPartialEmailTemplates.TRIGGER:
      return {
        ...state,
        emailTemplateListPartialLoading: true,
        emailTemplateListPartialSuccess: false,
      };
    case fetchPartialEmailTemplates.SUCCESS:
      return {
        ...state,
        emailTemplateListPartialLoading: false,
        emailTemplateListPartialSuccess: true,
        emailTemplateListPartial: action.payload?.data || [],
      };
    case fetchPartialEmailTemplates.FAILURE:
      return {
        ...state,
        emailTemplateListPartialLoading: false,
        emailTemplateListPartialSuccess: false,
      };

    // fetch email template by ID
    case fetchEmailTemplateById.TRIGGER:
      return {
        ...state,
        selectedEmailTemplateLoading: true,
        selectedEmailTemplateSuccess: false,
        selectedEmailTemplate: null,
      };
    case fetchEmailTemplateById.SUCCESS:
      return {
        ...state,
        selectedEmailTemplateLoading: false,
        selectedEmailTemplateSuccess: true,
        selectedEmailTemplate: action.payload || null,
      };
    case fetchEmailTemplateById.FAILURE:
      return {
        ...state,
        selectedEmailTemplateLoading: false,
        selectedEmailTemplateSuccess: false,
      };

    // create email template
    case createEmailTemplate.TRIGGER:
      return {
        ...state,
        emailTemplateCreateSuccess: false,
        emailTemplateCreating: true,
      };
    case createEmailTemplate.SUCCESS:
      return {
        ...state,
        emailTemplateCreateSuccess: true,
        emailTemplateCreating: false,
      };
    case createEmailTemplate.FAILURE:
      return {
        ...state,
        emailTemplateCreateSuccess: false,
        emailTemplateCreating: false,
      };

    // update email template
    case updateEmailTemplate.TRIGGER:
      return {
        ...state,
        emailTemplateUpdateSuccess: false,
        emailTemplateUpdating: true,
      };
    case updateEmailTemplate.SUCCESS:
      return {
        ...state,
        emailTemplateUpdateSuccess: true,
        emailTemplateUpdating: false,
      };
    case updateEmailTemplate.FAILURE:
      return {
        ...state,
        emailTemplateUpdateSuccess: false,
        emailTemplateUpdating: false,
      };

    // delete email template
    case deleteEmailTemplate.TRIGGER:
      return {
        ...state,
        emailTemplateDeleting: true,
      };
    case deleteEmailTemplate.SUCCESS:
    case deleteEmailTemplate.FAILURE:
      return {
        ...state,
        emailTemplateDeleting: false,
      };

    case duplicateEmailTemplate.TRIGGER: {
      return {
        ...state,
        emailTemplateDuplicating: true,
        emailTemplateDuplicateSuccess: false,
      };
    }
    case duplicateEmailTemplate.SUCCESS: {
      return {
        ...state,
        emailTemplateDuplicating: false,
        emailTemplateDuplicateSuccess: true,
      };
    }
    case duplicateEmailTemplate.FAILURE: {
      return {
        ...state,
        emailTemplateDuplicating: false,
        emailTemplateDuplicateSuccess: false,
      };
    }

    // reset selected email template
    case resetSelectedEmailTemplate.TRIGGER: {
      return {
        ...state,
        selectedEmailTemplate: null,
        selectedEmailTemplateLoading: false,
        selectedEmailTemplateSuccess: false,
      };
    }

    default:
      return state;
  }
};
export default emailTemplateReducer;
